/**
 * Leiste unter den Preisgrenzen: wo Mindest-, Referenz- und Maximalpreis auf einer gemeinsamen
 * Skala liegen. Nur gültige, positive Eingaben zählen; mit weniger als zwei Werten gibt es keine Skala.
 */
export interface PriceMark {
  key: 'minimum' | 'reference' | 'maximum';
  value: number;
  /** Position auf der Leiste in Prozent (0–100). */
  position: number;
}

const parse = (entry: string) => {
  if (entry.trim() === '') return null;
  const value = Number(entry);
  return Number.isFinite(value) && value > 0 ? value : null;
};

export function priceMarks(minimum: string, reference: string, maximum: string): PriceMark[] {
  const known = (
    [
      ['minimum', parse(minimum)],
      ['reference', parse(reference)],
      ['maximum', parse(maximum)],
    ] as const
  ).filter((entry): entry is readonly [PriceMark['key'], number] => entry[1] !== null);
  if (known.length < 2) return [];
  const values = known.map(([, value]) => value);
  const low = Math.min(...values);
  const high = Math.max(...values);
  // Rand links und rechts, damit Beschriftungen am Ende nicht abgeschnitten werden.
  const padding = high === low ? Math.max(low * 0.1, 1) : (high - low) * 0.12;
  const from = low - padding;
  const span = high + padding - from;
  return known.map(([key, value]) => ({
    key,
    value,
    position: Math.round(((value - from) / span) * 1000) / 10,
  }));
}
